import React, { useEffect } from "react";
import { twMerge } from "tailwind-merge";

import Icon from "../Icon";

type NavModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
  backNavClick?: () => void;
  containerClassNames?: string;
};

const NavModal = ({
  open,
  onClose,
  children,
  backNavClick,
  containerClassNames,
}: NavModalProps) => {
  useEffect(() => {
    if (open) {
      // Lock body scroll when modal is open
      document.body.style.overflow = "hidden";
    }

    return () => {
      // Restore body scroll when modal closes or component unmounts
      document.body.style.overflow = "unset";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className={twMerge(
        "h-full overflow-y-auto z-[1000] fixed inset-0 h-screen w-screen bg-deep-blue text-clear-sky",
        containerClassNames,
      )}
    >
      <div
        className={twMerge(
          "h-screen w-full max-w-lg sm:p-10 absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]",
        )}
      >
        <div>
          <div className="flex items-center justify-between">
            {backNavClick && (
              <div className="p-8 text-clear-sky" onClick={backNavClick}>
                <Icon name="arrow" />
              </div>
            )}
            <button
              className="p-8 text-clear-sky hover:text-studer-blue focus:outline-amalfi-coast"
              onClick={onClose}
              aria-expanded="true"
            >
              <Icon name="close" />
            </button>
          </div>
          <div className={"px-6 pb-4"}>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default NavModal;
